import React, { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE || "";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setStatus({ type: "", msg: "" });

    if (password.length < 8) {
      setStatus({ type: "error", msg: "Heslo musí mít alespoň 8 znaků." });
      return;
    }
    if (password !== password2) {
      setStatus({ type: "error", msg: "Hesla se neshodují." });
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        setStatus({ type: "error", msg: data?.message || "Chyba resetu hesla." });
      } else {
        // okamžitý redirect bez timeoutu
        navigate("/login");
      }      

    } catch (err) {
      setStatus({ type: "error", msg: "Chyba připojení k serveru." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-50">
      <div className="w-full max-w-md bg-white border rounded-2xl shadow p-6">
        <h1 className="text-2xl font-extrabold text-gray-900 mb-2">Nastavit nové heslo</h1>
        <p className="text-gray-600 mb-6">Zadej nové heslo pro svůj účet.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Nové heslo</label>
            <input
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type="password"
              required
              className="w-full rounded-xl border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Zopakovat heslo</label>
            <input
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              type="password"
              required
              className="w-full rounded-xl border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-600"
            />
          </div>

          {status.msg && (
            <div
              className={`rounded-xl px-3 py-2 text-sm ${
                status.type === "success"
                  ? "bg-green-50 text-green-800 border border-green-200"
                  : "bg-red-50 text-red-800 border border-red-200"
              }`}
            >
              {status.msg}
            </div>
          )}

          <button
            disabled={loading}
            className="w-full rounded-xl bg-blue-700 text-white font-semibold py-2 hover:bg-blue-800 disabled:opacity-60"
          >
            {loading ? "Ukládám..." : "Změnit heslo"}
          </button>
        </form>

        <div className="mt-4 text-sm text-gray-600">
          <Link to="/login" className="text-blue-700 hover:underline">
            Zpět na přihlášení
          </Link>
        </div>
      </div>
    </div>
  );
}